var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.theme.panel
  }, [_vm._t("default")], 2)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-01c53e07","hasScoped":false}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/baseComponents/components/Panel/Panel.vue
// module id = 621
// module chunks = 0